import BarcodeScannerService from './BarcodeScannerService';
import MagneticStripeScannerService from './MagneticStripeScannerService';
import CashDrawerService from './CashDrawerService';

export default {
  BarcodeScanner: new BarcodeScannerService(),
  MagneticStripeScanner: new MagneticStripeScannerService(),
  CashDrawer: new CashDrawerService(),
};
